import { render, staticRenderFns } from "./modal-workplace.vue?vue&type=template&id=66736cb1&scoped=true&"
import script from "./modal-workplace.vue?vue&type=script&lang=js&"
export * from "./modal-workplace.vue?vue&type=script&lang=js&"
import style0 from "./modal-workplace.vue?vue&type=style&index=0&id=66736cb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66736cb1",
  null
  
)

export default component.exports